import { IDataTableOrder } from '../../components/DataTable/types';

export const createOrderByFieldName = (fieldName: string, order: IDataTableOrder) => {
  return `${fieldName}_${order.toUpperCase()}`;
};
